import request from '@/utils/request'




/**
 * 查询消费金额以及扣卡等
 * @param data
 */
export function selectConsumeMoneyData(params) {
  return request({
    url: '/admin/bas/selectConsumeMoneyData',
    method: 'get',
    params: params
  })
}















// WEBPACK FOOTER //
// ./src/api/bas/basConsumeData.js